var render = function render(){var _vm=this,_c=_vm._self._c;return (Object.keys(_vm.item).length)?_c('div',_vm._l((_vm.item),function(value,key){return _c('div',{key:key},[_c('strong',[_vm._v(_vm._s(key)+" :")]),_vm._v(" "+_vm._s(value ? value : `${_vm.$t('merchandising.no_value_assigned')}`)+" ")])}),0):_c('div',[_vm._v(_vm._s(_vm.$t('merchandising.no_value_assigned')))])
}
var staticRenderFns = []

export { render, staticRenderFns }